module.exports = __webpack_public_path__ + "img/OracleEloquia.1fff4216.png";